import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SegmentedControl } from '~/components/SegmentedControl'
import { useBranding } from '~/helpers/branding/branding-context'
import { DATE_WITH_YEAR, formatSessionDate } from '~/helpers/dates/session-dates'
import { tourAnchor } from '~/helpers/tour/anchors'
import ImprovementActionsPanel from './ImprovementActionsPanel'
import QualityRisksPanel from './QualityRisksPanel'

type Tab = 'actions' | 'risks'

/**
 * Amélioration continue de l'organisme (#328), aux admins : le journal des
 * actions décidées à partir des retours, et le registre des risques qualité
 * (Qualiopi, indicateur 32).
 */
function QualityPage() {
  const { t, i18n } = useTranslation()
  const { timezone } = useBranding()
  const [tab, setTab] = useState<Tab>('actions')
  const formatDate = (value: unknown) => formatSessionDate(value, i18n.language, timezone, DATE_WITH_YEAR)

  return (
    <div className="flex w-full flex-col gap-6">
      <p className="text-sm text-muted-foreground" {...tourAnchor('quality.intro')}>{t('quality.intro')}</p>
      <div {...tourAnchor('quality.tabs')}>
        <SegmentedControl
          label={t('quality.tabs')}
          value={tab}
          onChange={setTab}
          options={[{ value: 'actions', label: t('quality.actions.title') }, { value: 'risks', label: t('quality.risks.title') }]}
        />
      </div>
      {tab === 'actions'
        ? <ImprovementActionsPanel formatDate={formatDate} timeZone={timezone} />
        : <QualityRisksPanel formatDate={formatDate} />}
    </div>
  )
}

export default QualityPage
